<template>
  <section
    class="date-list"
    :class="siteVariant"
  >
    <h2><span>Dates</span></h2>
    <ul class="wrapper">
      <li
        v-for="({ date, label, color }, ind) in dates"
        :key="`date-${ind}`"
        class="datebox"
      >
        <DateBackground :index="ind" :color="color"/>
        <span class="date">
          <span class="month">{{ date[0] }}</span>
          <span class="day">{{ date[1] }}</span>
          <span class="label">{{ label }}</span>
        </span>
      </li>
    </ul>
  </section>
</template>

<script setup>
import DateBackground from '@/components/svg/DateBackground.vue';

const props = defineProps({
  siteVariant: String,
});

const dates = [
  { date: ['April', '7'], label: 'Website Submissions Open' },
  { date: ['April', '25'], label: 'Submission Deadline', color: '#4d4d4d' },
  { date: ['May', '2'], label: 'Submission Deadline Has Been Extended', color: '#ff0f0f' },
  { date: ['May', '12'], label: 'Announcement of Zone Winners & National Finalists' },
  { date: ['June', props.siteVariant === 'acura' ? '16-18' : '18-20'], label: 'Final Live Competition in Las Vegas' },
];
</script>

<style lang="scss" scoped>
.date-list {
  background-color: $AC_Navy;
  padding-bottom: 70px;
  margin-top: 40px;

  @media (min-width: 1025px) {
    padding-bottom: 150px;
    margin-top: 0;
  }

  h2 {
    font-size: clamp(29px, 83px, 6vw);
    font-weight: 500;
    color: $AC_White;
    line-height: 1.2;
    text-transform: uppercase;
    text-align-last: left;
    padding: 0 20px 24px;
    display: flex;
    align-items: baseline;
    gap: 15px;
    max-width: 1680px;
    margin: 0 auto;

    @media (min-width: 1025px) {
      padding-bottom: 70px;
      gap: 40px;
    }

    &::after {
      content: '';
      flex: 1;
      height: 2px;
      background-color: $AC_Orange;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    margin: 20px auto 0;
    max-width: 1550px;
    padding: 0 15px;

    @media (min-width: 1100px) {
      flex-direction: row;
      gap: 20px;
    }

    @media (min-width: 1281px) {
      gap: 40px;
    }
  }

  svg {
    display: block;
    width: 100%;
    height: auto;
  }

  .datebox {
    position: relative;
    width: 261px;

    @media (min-width: 1600px) {
      width: auto;
    }
  }

  .date {
    position: absolute;
    left: 30px;
    top: 30px;
    color: $AC_White;
    text-align: left;

    span {
      display: block;
    }
  }

  .month {
    font-size: 22px;
    text-transform: uppercase;
  }

  .day {
    font-size: 60px;
    line-height: 1;
    margin-bottom: 20px;
  }

  .label {
    font-size: 21px;
    line-height: 1.2;
    max-width: 175px;
  }

  @media (min-width: 1600px) {
    .month {
      font-size: 31px;
    }

    .day {
      font-size: 83px;
    }

    .label {
      font-size: 30px;
      max-width: 250px;
    }
  }

  &.acura {
    .month {
      font-family: 'Avenir Book', sans-serif;
    }

    .day {
      font-family: 'Avenir Heavy', sans-serif;
    }

    .label {
      font-weight: 300;
    }
  }

  &.honda {
    .day {
      font-weight: 700;
    }
  }
}
</style>
